export function getShortenAddress(
  value: string,
  startChars: number = 6,
  endChars: number = 4,
  separator: string = "...",
): string {
  if (!value || value.length <= startChars + endChars) {
    return value;
  }
  return `${value.slice(0, startChars)}${separator}${value.slice(-endChars)}`;
}
